import styled from 'styled-components';
import * as awsui from '@amzn/awsui-design-tokens';

export const Body = styled.div`
    margin-top: 0;
    background-color: ${awsui.colorBackgroundLayoutMain};
    
    .text-editor {
        border: 1px solid ${awsui.colorBorderDividerDefault};
        border-radius: 3px;
        font-size: 14px;
        height: 250px;
        overflow-y: scroll;
    }

    .text-editor .ProseMirror {
        height: 248px;
        padding: 10px;
        overflow: scroll;

        border: 1px solid ${awsui.colorBorderDividerDefault};
    }

    .text-editor:active {
        height: 250px;
        overflow-y: scroll;
    }

    .text-editor:focus {
        height: 250px;
        overflow-y: scroll;
    }

    .text-editor:focus-within {
        height: 250px;
        overflow-y: scroll;
    }
    
    .text-editor:target {
        height: 250px;
        overflow-y: scroll;
    }
`;
